import React from 'react';

import styles from './BeneficiaryCol.module.css';

interface IBeneficiaryCol {
  label: string;
  value: string;
  width: string;
  minWidth: string;
}

const BeneficiaryCol = ({ label, value, width = '100%', minWidth = '300px' }: IBeneficiaryCol) => (
  <div style={{ flex: `1 1 ${width}`, minWidth }} className={styles.nameField}>
    <div className={styles.fieldLabel}>{label}</div>
    <div className={styles.fieldValue}>{value}</div>
  </div>
);

export default BeneficiaryCol;
